import { IAdmin } from "src/models";
import * as Types from "src/redux/types";

type State = {
  shops: IAdmin[];
  isLoaded: boolean;
};

const initialState: State = {
  shops: [],
  isLoaded: false,
};

const ShopsReducer = (
  state = initialState,
  action: Action<IAdmin[]>
): State => {
  const { type, payload } = action;
  switch (type) {
    case Types.SHOPS_LOAD: {
      const data = payload as IAdmin[];
      return {
        ...state,
        shops: data,
        isLoaded: true,
      };
    }

    default:
      return state;
  }
};

export default ShopsReducer;
